import DomEventManager from '../../utils/DomEventManager';

export interface BulkActionEventData {
    selectedListings: string[];
    shouldSelectAll: boolean;
}

export type BulkActionDropdownCustomEventType = CustomEvent<BulkActionEventData>;

class BulkActionEventManager<BulkActionEventData> extends DomEventManager<BulkActionEventData> {
    public selectedListings: string[];
    public shouldSelectAll: boolean;

    protected constructor(event_name: string) {
        super(event_name);

        this.selectedListings = [];
    }

    public static create <BulkActionEventData>(eventName: string) : BulkActionEventManager<BulkActionEventData> {
        return new BulkActionEventManager(eventName);
    }

    public store = (listingToAdd: string) => {
        this.selectedListings.push(listingToAdd);
        
        this.dispatch(null);
    }

    public remove = (listingToRemove: string) => {
        const index = this.selectedListings.indexOf(listingToRemove);
        if (index === -1) {
            return;
        }

        this.selectedListings.splice(index, 1);
        this.dispatch(null);
    }

    public setShouldSelectAll = (value: boolean) => {
        this.shouldSelectAll = value;

        this.dispatch({ selectedListings: this.selectedListings, shouldSelectAll: this.shouldSelectAll } as BulkActionEventData)
    }
}

export default BulkActionEventManager;
